const AZ_ORDINAL_ENDINGS: Record<Intl.LDMLPluralRule, string> = {
  zero: 'ci',
  one: 'ci',
  two: 'ci',
  few: 'cü',
  many: 'cı',
  other: 'cu'
};

const azOrdinalPluralRules = new Intl.PluralRules('az', { type: 'ordinal' });

export const getAzerbaijaniNumberEnding = (n: number): string =>
  AZ_ORDINAL_ENDINGS[azOrdinalPluralRules.select(n)];

export const formatAzerbaijaniNumberEnding = (value: unknown): string => {
  const str = String(value ?? '');
  const last = Number(str.split('-').pop());

  if (!Number.isInteger(last) || last < 1) return str;

  return `${str}-${getAzerbaijaniNumberEnding(last)}`;
};
